/**
 * Formats a Date as a naive `YYYY-MM-DD HH:mm:ss` string for backend
 * time-window params (`start_time` / `end_time` / `timestamp`).
 *
 * The backend interprets these naive strings as UTC (verified empirically:
 * querying `12:00:00–12:10:00` returns events stamped `…T12:0x:xxZ`), so the
 * string must carry the Date's UTC components. Emitting local components here
 * shifted every requested window by the user's UTC offset (e.g. a "last 30
 * minutes" realtime window landed 2h in the future for UTC+2 users).
 */
export const formatDateTime = (date: Date, _boundary?: "start" | "end") => {
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  const seconds = String(date.getUTCSeconds()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};
